export default __webpack_public_path__ + "static/media/cute-puppies.7b6cf90a.jpg";